<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}">
</ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3">FAQ</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">FAQ</li>
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">
                        <a href="javascript:void(0)" class="btn brand-border-btn" routerLink="/faq-add">
                            Add FAQ
                        </a>
                    </div>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row align-items-end">
                <!-- <div class="col-12 col-sm-4 col-lg-3 pb-3" *ngIf="dataListing.length > 0">
                    <label for="inputState" class="form-label">Limit</label>
                    <select id="inputState" class="form-select" [(ngModel)]='pageLimit' (change)="getDetail(1)">
                    <option *ngFor="let item of service.LimitArray">{{item}}</option>
                    </select>
                </div> -->
                <!-- <div class="col-12 col-sm-4 col-lg-3 pb-3">
                    <label for="inputState" class="form-label">Search</label>
                    <input type="text" id="inputState" class="form-control" placeholder="Search By Name" [(ngModel)]='searchKey' (keyup)="getDetail(1)">
                </div>

                <div class="col-12 col-sm-4 col-lg-3 pb-3 pt-sm-4">
                    <button type="button" class="btn custom-btn btn-danger px-4" (click)="reset()">Reset</button>
                </div> -->
                <div class="col-12">
                    <div class="card">
                        <div class="card-body  table-responsive">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Question</th>
                                        <th scope="col">Answer</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0">
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td class="text-wrap"  [title]="item.question">{{item.question | truncate:30}}</td>
                                        <td class="text-wrap"  [title]="item.answer">{{item.answer | truncate:30}}</td>
                                        <td>{{service.dateCon(item.createdAt) }} </td>
                                        <td><span class="badge bg-success" *ngIf="item.status =='Active'">{{item.status}}</span>
                                            <span class="badge bg-danger" *ngIf="item.status !='Active'">In-Active</span>
                                        </td>
                                        <td>
                                            <div class="box-btn">
                                                <button type="button" title="Update" class="btn btn-info text-center me-2" (click)="redirect(item,1)">
                                                    <i class="bx bx-pencil" ></i>
                                                </button>
                                                <button type="button" title="Delete" class="btn btn-danger text-center" (click)="redirect(item,2)">
                                                    <i class="bx bx-trash" ></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end row-->
        </div>
    </div>
    <app-footer></app-footer>
</div>